import { apiRequest } from "@core/services/api/apiRequest";

export interface TranscriptionToggleResponse {
  message: string;
  cc_status: 'on' | 'off';
  expires_at?: string;
  meeting_id: number;
}

export const turnOnMeetingTranscription = async (meetingId: number): Promise<TranscriptionToggleResponse> => {
  return apiRequest(`/api/meetings/${meetingId}/transcription/on/`, 'POST');
};
